<main class="register-page d-flex justify-content-center mb-5 px-3 pt-2">
    <section class="register-panel w-100">
        <header class="register-header d-flex flex-column mb-4">
            <h3 class="p-0 mb-0">Account aanmaken</h3>
            <p class="mb-0 text-muted">Vul onderstaand formulier in om uw account voor de Dirk-app aan te maken.</p>
        </header>

        <form #registerForm="ngForm" (submit)="save(registerForm)" class="register-form d-flex flex-column">
            <section class="register-section d-flex flex-column mb-4">
                <div class="register-fields">
                    <mat-form-field class="w-100">
                        <input
                            type="text"
                            [(ngModel)]="user.name"
                            name="name"
                            id="name"
                            placeholder="Voornaam"
                            required
                            #name="ngModel"
                            matInput />
                    </mat-form-field>
                    @if (showError(name, 'required')) {
                        <div class="text-danger small mt-n2 mb-2">Voornaam is verplicht</div>
                    }

                    <mat-form-field class="w-100">
                        <input
                            type="text"
                            [(ngModel)]="user.lastname"
                            id="lastname"
                            name="lastname"
                            placeholder="Achternaam"
                            required
                            #lastname="ngModel"
                            matInput />
                    </mat-form-field>
                    @if (showError(lastname, 'required')) {
                        <div class="text-danger small mt-n2 mb-2">Achternaam is verplicht</div>
                    }

                    <mat-form-field class="w-100">
                        <input
                            type="email"
                            [(ngModel)]="user.email"
                            (ngModelChange)="clearEmailInUse($event)"
                            id="email"
                            name="email"
                            placeholder="E-mailadres"
                            required
                            email
                            pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                            #email="ngModel"
                            matInput />
                    </mat-form-field>
                    @if (showError(email, 'required')) {
                        <div class="text-danger small mt-n2 mb-2">E-mailadres is verplicht</div>
                    } @else if (showError(email, 'email') || showError(email, 'pattern')) {
                        <div class="text-danger small mt-n2 mb-2">Vul een geldig e-mailadres in</div>
                    } @else if (emailIsInUse()) {
                        <div class="text-danger small mt-n2 mb-2">Dit e-mailadres is al in gebruik</div>
                    }

                    <mat-form-field class="w-100">
                        <input
                            type="tel"
                            [(ngModel)]="user.phone"
                            name="phone"
                            placeholder="Telefoonnummer"
                            id="phone"
                            pattern="^[+()0-9\s\-]{7,20}$"
                            #phone="ngModel"
                            matInput />
                    </mat-form-field>
                    @if (showError(phone, 'pattern')) {
                        <div class="text-danger small mt-n2 mb-2">Vul een geldig telefoonnummer in</div>
                    }
                </div>
            </section>

            <div class="register-actions d-flex flex-column mt-0">
                <button
                    type="submit"
                    [disabled]="submitDisabled || registerForm.invalid"
                    class="w-100"
                    mat-raised-button
                    color="primary">
                    {{ submitText }}
                </button>
                <button
                    [routerLink]="['/', Routenames.login]"
                    class="w-100"
                    tabindex="-1"
                    mat-stroked-button
                    color="warn">
                    Annuleren
                </button>
            </div>
        </form>
    </section>
</main>
